<template>
  <div class="container">
    <div class="navi">
      <span class="close"><span class="icon-arrow-left" @click="goback()"></span></span>
      <div class="top-title">{{ vehicle_info.vehicle }}报价详情</div>
      <span></span>
    </div>

    <div class="vehicle_img">
      <img src="../../../static/img/move/vehicle/logo.png">
      <h1>{{ vehicle_info.vehicle }}报价表</h1>
      <p>客服电话：0477747777</p>
      <img :src="vehicle_info.truck_img1">
    </div>
    <div class="vehicle_Size_div ">
      <div class="vehicleSize weui-flex">
        <div class="weui-flex__item intro">
          <div class="intro">装载空间：</div>
        </div>
        <div class="weui-flex__item sizeDescription">
          <div class="weui-flex text-center">
            <div class="weui-flex_item">{{ vehicle_info.spase[0] }}</div>
            <div class="weui-flex_item icon-times-typicon"></div>
            <div class="weui-flex_item">{{ vehicle_info.spase[1] }}</div>
            <div class="weui-flex_item icon-times-typicon"></div>
            <div class="weui-flex_item">{{ vehicle_info.spase[2] }}</div>
          </div>
        </div>
      </div>
      <div class="vehicleSize weui-flex">
        <div class="weui-flex__item">
          <div class=" intro">装载体积：</div>
        </div>
        <div class="weui-flex__item sizeDescription">
          <div class="">{{ vehicle_info.load_capacity }}</div>
        </div>
      </div>
      <div class="vehicleSize weui-flex">
        <div class="weui-flex__item">
          <div class=" intro" v-if="$route.query.v == '1'">不可装载：</div>
          <div class=" intro" v-else>适用房型：</div>
        </div>
        <div class="weui-flex__item sizeDescription suitable_room">
          <div class="">{{ vehicle_info.suitable_room_type }}</div>
        </div>
      </div>
    </div>

    <div class="quality">
      <div class=" weui-flex">
        <div class="weui-flex__item">
          <div class="">
            <img src="/static/img/move/vehicle/1.png" />
          </div>
        </div>
        <div class="weui-flex__item">
          <div class="">
            <img src="/static/img/move/vehicle/2.png" />
          </div>
        </div>
        <div class="weui-flex__item">
          <div class="">
            <img src="/static/img/move/vehicle/3.png" />
          </div>
        </div>
      </div>
      <div class="weui-flex">
        <div class="weui-flex__item">
          <div class="">明码标价<br />
            <p>杜绝坐地起价</p>
          </div>
        </div>
        <div class="weui-flex__item">
          <div class="">全程搬运<br />
            <p>无需自己动手</p>
          </div>
        </div>
        <div class="weui-flex__item">
          <div class="">物损保障<br />
            <p>损坏赔付</p>
          </div>
        </div>
      </div>
    </div>

    <div class="core">
      <div class="pricing_zone pricing_filling">
        <div class="item-head">
          <span class="itemtext ">
            <h1 class="pricing_title">价格包含</h1>
          </span>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item left-flexGrow">
            <div class=" pull-left">车辆规格</div>
          </div>
          <div class="weui-flex__item right-flexGrow">
            <div class=" pull-right color-orange">{{ vehicle_info.capacity }}</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item">
            <div class=" pull-left">车辆提供</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">包含</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item">
            <div class=" pull-left">服务人员</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">{{ vehicle_info.waiter }}</div>
            <div v-if="['2', '3', '4', '5'].includes($route.query.v)" class="pull-right color-orange right_text">
              可增加车辆,详情请咨询客服
            </div>
          </div>
        </div>
<!--         <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item">
            <div class=" pull-left">顾客可搭乘人数</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">{{ vehicle_info.customer }}</div>
          </div>
        </div> -->
        <div class="pricing_filling weui-flex item last paragraph">
          <div class="weui-flex__item left-flexGrow">
            <div class=" pull-left">配载工具</div>
          </div>
          <div class="weui-flex__item right-flexGrow">
            <div class="pull-right color-orange right_text ">电动家具拆装工具、两轮Trolley四轮Dolley、保护毯、绳子等</div>
          </div>
        </div>
      </div>

      <div class="pricing_zone pricing_filling">
        <div class="item-head">
          <span class="itemtext pricing_title">收费标准</span>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item">
            <div class=" pull-left">基础服务费</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">{{ vehicle_info.basic_service_fee }}</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item">
          <div class="weui-flex__item">
            <div class=" pull-left">楼梯费</div>
            <div class=" pull-left left_text">
              总价加收的一次性费用不随时间累积和次数叠加
            </div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">{{ vehicle_info.stair_fee }}</div>
            <div class="pull-right color-orange right_text flex_text">
              平层或电梯无楼梯费
            </div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item">
          <div class="weui-flex__item text_long">
            <div class=" pull-left">出车回程费</div>
            <div class=" pull-left left_text ">
              一次性收费，会依据距离远近上调或下调费用，具体请以客服报价为准
            </div>
          </div>
          <div class="weui-flex__item text_short">
            <div class=" pull-right color-orange ">{{ vehicle_info.return_fee }}</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item">
            <div class=" pull-left ">起步时数</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange">{{ vehicle_info.start_number }}</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item paragraph">
          <div class="weui-flex__item text_short">
            <div class=" pull-left">计费方式</div>
          </div>
          <div class="weui-flex__item text_long">
            <div class=" pull-right color-orange">
              按时间计费,车到计时
            </div>
          </div>
        </div>
        <div class="total_cost weui-flex weui-article">
          <div class="weui-flex__item color-orange text">总费用</div>
          <div class="weui-flex__item icon-equal-typicon"></div>
          <div class="weui-flex__item color-yellow text">基础服务费</div>
          <div class="weui-flex__item icon-times-typicon"></div>
          <div class="weui-flex__item color-yellow text">时间</div>
          <div class="weui-flex__item icon-plus-typicon"></div>
          <div class="weui-flex__item color-orange text">楼梯费</div>
          <div class="weui-flex__item icon-plus-typicon"></div>
          <div class="weui-flex__item color-orange text">回程费</div>
        </div>
      </div>

      <div class="pricing_zone pricing_filling">
        <div class="item-head">
          <span class="itemtext pricing_title">额外选取收费项目</span>
        </div>
        <div class="pricing_filling weui-flex item">
          <div class="weui-flex__item text_long">
            <div class=" pull-left">纸盒箱</div>
            <div class="pull-left left_text text_div">
              <ul class="weui-flex flex_text">
                <li class="weui-flex_item">102升，长57.5cm</li>
                <li class="weui-flex_item icon-times-typicon"></li>
                <li>宽35cm</li>
                <li class="weui-flex_item icon-times-typicon"></li>
                <li>高51cm</li>
              </ul>
            </div>
          </div>
          <div class="weui-flex__item text_short" v-if="$route.query.v == '1'">
            <!-- <div class=" pull-right color-orange event-free">限时免费<span><br>$5一个</span></div> -->
            <div class=" pull-right color-orange">$6一个</div>
          </div>
          <div class="weui-flex__item text_short" v-else>
            <div class=" pull-right color-orange">$6一个</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item">
          <div class="weui-flex__item text_long">
            <div class=" pull-left ">床垫套</div>
            <div class="pull-left left_text flex_text">Queen Size,Doble Size,Single Size</div>
          </div>
          <div class="weui-flex__item text_short">
            <div class=" pull-right color-orange">$8一个</div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item">
          <div class="weui-flex__item">
            <div class=" pull-left">Toll收费公路费用</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange right_text">
              若您选择走收费公路<br />由您承担相应toll费用
            </div>
          </div>
        </div>
        <div class="pricing_filling weui-flex item last">
          <div class="weui-flex__item">
            <div class=" pull-left">重物费</div>
          </div>
          <div class="weui-flex__item">
            <div class=" pull-right color-orange right_text">
              过重或易碎的特殊物品<br />详情请咨询客服
            </div>
          </div>
        </div>
      </div>

      <div class="pricing_title">注意事项</div>
      <div class="weui-flex precautions">
        <div class="weui-flex__item">
          <ul v-if="$route.query.v == '1'">
            <li>&nbsp;非正常工作时间和公众假日，价格可能会有所上浮，详情请咨询客服</li>
            <li>&nbsp;车库或Loading Dock所需高度为2.1米以上。</li>
          </ul>
          <ul v-if="['2', '3', '4', '5'].includes($route.query.v)">
            <li>&nbsp;需提前预定Loading Dock和电梯。</li>
            <li>&nbsp;车库或Loading Dock所需高度为{{ vehicle_info.seight_limit }}米以上。</li>
            <li>&nbsp;3吨限行路段的住宅需要提前联系本区Council预定搬家。</li>
            <li>&nbsp;非正常工作时间和公众假日，价格可能会有所上浮，详情请咨询客服。</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="btn-box" v-show="$route.query.step == 'vehicle'">
      <div class="btn active" @click="goto('move-step2')">使用此车型</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "step3in",
  data() {
    return {
      order: {},
    };
  },
  created() {
    document.querySelector("html").classList.add("vehicle-bg");
  },
  destroyed() {
    document.querySelector("html").classList.remove("vehicle-bg");
  },
  methods: {
    goback() {
      if (this.$route.query.action == "back") {
        this.$router.go(-1);
      } else {
        this.goto("move-step2");
      }
    },
  },
  computed: {
    vehicle_info: function () {
      let result = "";
      switch (this.$route.query.v) {
        case "1":
          result = {
            vehicle: "面包车",
            truck_img1: "/static/img/move/vehicle/van/1.png",
            spase: ['长1.9m', '宽1.55m', '高1.31m'],
            load_capacity: "6立方",
            suitable_room_type: "King size床的床垫和Base，Queen size床的床垫和Base，冰箱不可立放",
            capacity: "到家6立方小件专用面包车",
            waiter: "1名",
            customer: "1名",
            basic_service_fee: "$60每小时",
            stair_fee: "$10每楼层",
            return_fee: "$50起",
            start_number: "1小时起步",
          };
          break;
        case "2":
          result = {
            vehicle: "小型箱货",
            truck_img1: "/static/img/move/vehicle/s/1.png",
            spase: ['长4.2m', '宽2.1m', '高2.1m'],
            load_capacity: "19立方",
            suitable_room_type: "一房、Studio或两房一厅正常数量家具家电和行李",
            capacity: "到家4.5吨升降机卡车",
            waiter: "2名",
            customer: "1名",
            basic_service_fee: "$110每小时",
            stair_fee: "$20每楼层",
            return_fee: "$110起",
            start_number: "2小时起步",
            seight_limit: "3.3",
          };
          break;
        case "3":
          result = {
            vehicle: "中型箱货",
            truck_img1: "/static/img/move/vehicle/m/1.png",
            spase: ['长4.46m', '宽2.42m', '高2.52m'],
            load_capacity: "27立方",
            suitable_room_type: "两房一厅户型或两房一厅+Study房型",
            capacity: "到家6.5吨升降机卡车",
            waiter: "2名",
            customer: "1名",
            basic_service_fee: "$120每小时",
            stair_fee: "$20每楼层",
            return_fee: "$120起",
            start_number: "2小时起步",
            seight_limit: "3.5",
          };
          break;
        case "4":
          result = {
            vehicle: "大型箱货",
            truck_img1: "/static/img/move/vehicle/l/1.png",
            spase: ['长5.23m', '宽2.42m', '高2.34m'],
            load_capacity: "30立方",
            suitable_room_type: "两房一厅东西偏多户型或三房一厅正常数量的家具家电和行李",
            capacity: "到家7.5吨升降机卡车",
            waiter: "2名",
            customer: "1名",
            basic_service_fee: "$130每小时",
            stair_fee: "$20每楼层",
            return_fee: "$130起",
            start_number: "2小时起步",
            seight_limit: "3.4",
          };
          break;
        case "5":
          result = {
            vehicle: "特大箱货",
            truck_img1: "/static/img/move/vehicle/xl/1.png",
            spase: ['长7.05m', '宽2.4m', '高2.4m'],
            load_capacity: "41立方",
            suitable_room_type: "三房两厅或三房以上户型的家具家电和行李",
            capacity: "到家10吨升降机卡车",
            waiter: "2名",
            customer: "1名",
            basic_service_fee: "$140每小时",
            stair_fee: "$20每楼层",
            return_fee: "$140起",
            start_number: "5小时起步",
            seight_limit: "3.5",
          };
          break;
        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    },




  }


};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

li {
  list-style: none;
}

.text-center {
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.container {
  padding-top: 61px;
  padding-bottom: 0;
  margin-bottom: -60px;
}

.navi {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 0;
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);

  span {
    flex: 1;
  }

  div {
    flex: 2;
  }

  .close {
    text-align: left;
    font-size: 1em;

    .icon-arrow-left {
      margin-right: 12px;
      margin-top: 12px;
      display: inline-block;
    }
  }
}

.icon-arrow-left {
  padding-left: 12pt;
}

.icon-equal-typicon,
.icon-times-typicon,
.icon-plus-typicon {
  font-size: 2em;
}

.top-title {
  font-size: 0.5em;
  line-height: 3.2em;
  color: #444;
  vertical-align: top;
  display: inline-block;
  text-align: center;
}

.btn-box {
  margin: -10px 0 40px 0;
}

.quality {
  padding: 10px 20px;
  font-size: 5vw;
  font-weight: bolder;

  .weui-flex__item {
    text-align: center;
  }

  img {
    display: inline-block;
    height: auto;
    max-width: 60%;
  }

  p {
    font-weight: lighter;
    font-size: 3.5vw;
    color: #999caf;
  }
}

.vehicle_Size_div {
  margin: 20px 10px 0 10px;
  line-height: 1.1em;

  .vehicleSize {
    padding: 0px 20px;
    font-size: 4vw;
    line-height: 1.7em;

    .intro {
      white-space: nowrap;
      text-align: center;
      flex-grow: 1;
      width: 90px;
    }

    .sizeDescription {
      flex-grow: 3;
      width: 100%;


    }
  }
}

.weui-flex__item {
  justify-content: center;
}

.core {
  padding: 0 10px 10px 10px;
}

.vehicle_img {
  background-image: url(../../../static/img/move/vehicle/bg.png);
  background-size: cover;
  background-position: center;
  padding: 30px 35px 0 35px;
  color: #f5f5f5;

  h1 {
    font-size: 9vw;
    font-weight: bolder;
    line-height: 9.5vw;
  }

  p {
    font-size: 4.5vw;
    padding-bottom: 30px;
  }
}

.vehicle_img img:first-child {
  height: 9vw;
  padding-bottom: 15px;
}

.pricing_title::before {
  content: '|';
  color: #ff7444;
  font-size: 5.5vw;
  padding: 0 5px 0 0;
}

.pricing_title {
  font-size: 5.5vw;
  font-weight: bold;
}

.pricing_zone {
  border: 1px solid #eee;
  background: #fff;
  border-radius: 8px;
  -webkit-box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
  box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 4.5vw;

}

.pricing_filling {
  padding: 10px 20px;
  -webkit-box-align: center;
  /*旧版本*/
  -moz-box-align: center;
  /*旧版本*/
  -ms-flex-align: center;
  /*混合版本*/
  -webkit-align-items: center;
  /*新版本*/
  align-items: center;
  /*新版本*/
}

.item {
  padding: 7px 0;
  border-bottom: 1px solid #eee;
}

.item.last {
  border-bottom: 0;
}

.paragraph {
  min-height: 2.5em;
}

.text_long {
  flex-grow: 3;
}

.left-flexGrow {
  flex-grow: 1;
}

.right-flexGrow {
  flex-grow: 2;
}

.text_short {
  flex-grow: 2;
}

.left_text {
  width: 22em;
  text-align: left;
  font-size: 0.5em;
  display: block;
  align-items: center;
  color: #999caf;

}

.flex_text {
  white-space: nowrap;
  align-items: center;
}

.right_text {
  width: 100%;
  text-align: right;
  font-size: 0.5em;
}


.total_cost {
  background: #f5f5f5;
  color: #5a5d67;
  margin: 20px 0 10px 0;
  padding: 10px 10px;
  border-radius: 4px;
  display: flex;
  font-size: 0.5em;
  text-align: center;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  .text {
    flex-shrink: 1.5;
    white-space: nowrap;
    font-weight: bolder;
    font-size: 3.5vw;
  }

  .iconfont {
    flex-shrink: 2;
    font-size: 3.5vw;
  }
}

.precautions {
  padding: 5px 5px;
  line-height: 30px;
  text-align: left;
  margin: 15px 15px 0 15px;
  font-size: 1em;
  color: #7e828d;

  .pricing_title {
    padding: 0 0 10px 0;
  }

  ul {
    counter-reset: section;

  }

  li::before {
    counter-increment: section;
    content: counters(section, '.') ' ';
    background-color: #ff7444;
    display: inline-block;
    width: 5vw;
    height: 5vw;
    color: #ffffff;
    border-radius: 100%;
    text-align: center;
    line-height: 5vw;
    font-size: 5vw;
    text-indent: 0em;
  }

  li {
    font-size: 4vw;
    line-height: 7vw;
    text-indent: -1.5em;
    margin-left: 1em;
  }
}

.event-free{
  line-height:1.1;
  text-align:center;
  color:#fb6882;
  span{
    font-size:0.9em;
    color:#aaa;
    text-decoration: line-through
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/move/vehicle.vue